import { WLOrderFormProvider, type Security } from '@talos/kyoko';
import type { PropsWithChildren } from 'react';

const getStrategiesBySymbol = (s: Security) => s.SupportedStrategies ?? [];

export function GCashOrderFormProvider({ children }: PropsWithChildren) {
  return <WLOrderFormProvider getStrategiesBySymbol={getStrategiesBySymbol}>{children}</WLOrderFormProvider>;
}
